import { render, staticRenderFns } from "./tab-item.vue?vue&type=template&id=dc9ebdde&scoped=true"
import script from "./tab-item.vue?vue&type=script&lang=js"
export * from "./tab-item.vue?vue&type=script&lang=js"
import style0 from "./tab-item.vue?vue&type=style&index=0&id=dc9ebdde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9ebdde",
  null
  
)

export default component.exports